/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_api': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M484.333 256c0-19.731-2.515-39.248-7.485-58.162l28.9-21.26-56.093-97.155-32.912 14.42c-28.139-27.938-62.594-47.847-100.69-58.18L312.092 0H199.907l-3.962 35.662c-38.095 10.333-72.55 30.242-100.688 58.18l-32.913-14.42-56.092 97.155 28.899 21.261c-4.97 18.914-7.484 38.432-7.484 58.162s2.515 39.248 7.484 58.162l-28.899 21.26 56.092 97.155 32.913-14.42c28.139 27.939 62.594 47.848 100.688 58.18L199.907 512h112.186l3.962-35.663c38.096-10.332 72.551-30.242 100.69-58.18l32.912 14.42 56.093-97.155-28.9-21.26c4.969-18.917 7.483-38.432 7.483-58.162zm-168.782-34.339l21.434-20.991 54.862 56.019-56.019 54.863-20.99-21.433 34.585-33.872zm-66.206 138.762l-29.357-6.18 42.667-202.666 29.357 6.18zm-52.183-70.305l-20.99 21.433-56.02-54.863 54.862-56.019 21.434 20.991-33.872 34.586z"/>'
  }
})
